import { render, staticRenderFns } from "./LeaningStatus.vue?vue&type=template&id=56ec52cc"
import script from "./LeaningStatus.vue?vue&type=script&lang=js"
export * from "./LeaningStatus.vue?vue&type=script&lang=js"
import style0 from "./LeaningStatus.vue?vue&type=style&index=0&id=56ec52cc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports